module.exports = __webpack_public_path__ + "static/media/Banner Lateral.2d99de66.png";